import { useState } from "react";
import ModalCreateUpdateBook from "../ModalCreateUpdateBook";
import styles from "./styles.module.css";

export default function BookCreateButton({ collectionRef, isVirtual, updateTableData }) {

    const [modal, setModal] = useState(false);

    return (<>

        <div className={styles.buttonContainer}>
            <button onClick={() => { setModal(true) }} className={styles.createButton}>{isVirtual ? 'Novo E-book' : 'Novo Livro'}</button>
        </div>

        {modal && <ModalCreateUpdateBook updateTableData={updateTableData} collectionRef={collectionRef} setModalVisible={() => { setModal() }} update={false} bookId="" isVirtual={isVirtual} />}

    </>)
}